import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaMudancaCategoriaRequest } from './types';

// ACTIONS
import {
	consultaMudancaCategoriaSuccess,
	consultaMudancaCategoriaFailure,
} from './actions';

function* consultaMudancaCategoria(request: ReducerAction) {
	const { payload }: { payload: ConsultaMudancaCategoriaRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`eportal/${CHANNEL}/pesquisa/mudanca-categoria`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaMudancaCategoriaSuccess({ response, request: payload }));
	} else {
		yield put(
			consultaMudancaCategoriaFailure({
				response: response.data,
				request: payload,
			}),
		);
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_MUDANCA_CATEGORIA_CNH_REQUEST,
		consultaMudancaCategoria,
	),
]);
